import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit{
  private config: {version: string}; 
  constructor(private httpClient: HttpClient) {
  }
  
  ngOnInit(): void {
    this.config = require('./../assets/config.json'); 
    console.log(this.config.version);

    const headers = new HttpHeaders()
      .set('Cache-Control', 'no-cache')
      .set('Pragma', 'no-cache'); 
    this.httpClient
      .get<{ version: string }>("/assets/config.json", {headers})
      .subscribe(config => {
        if (config.version !== this.config.version) {
          window.location.reload(); 
        }
      });

  }
  title = 'Inge app';
}
